module.exports = {
  ABNA: 'ABNANL2A',
  FTSB: 'ABNANL2A',
  AEGO: 'AEGONL2U',
  ANAA: 'ANAANL21',
  ANDL: 'ANDLNL2A',
  ARBN: 'ARBNNL22',
  ARSN: 'ARSNNL21',
  ARTE: 'ARTENL2A',
  ASNB: 'ASNBNL21',
  ASRB: 'ASRBNL2R',
  ATBA: 'ATBANL2A',
  BBRU: 'BBRUNL2X',
  BCDM: 'BCDMNL22',
  BCIT: 'BCITNL2A',
  BICK: 'BICKNL2A',
  BINK: 'BINKNL21',
  BKCH: 'BKCHNL2R',
  BKMG: 'BKMGNL2A',
  BLGW: 'BLGWNL21',
  BMEU: 'BMEUNL21',
  BNGH: 'BNGHNL2G',
  BNPA: 'BNPANL2A',
  BOFA: 'BOFANLNX',
  BOFS: 'BOFSNL21',
  BOTK: 'BOTKNL2X',
  BUNQ: 'BUNQNL2A',
  CHAS: 'CHASNL2X',
  CITC: 'CITCNL2A',
  CITI: 'CITINL2X',
  COBA: 'COBANL2X',
  DEUT: 'DEUTNL2N',
  DHBN: 'DHBNNL2R',
  DLBK: 'DLBKNL2A',
  DNIB: 'DNIBNL2G',
  FBHL: 'FBHLNL2A',
  FLOR: 'FLORNL2A',
  FRBK: 'FRBKNL2L',
  FRGH: 'FRGHNL21',
  FVLB: 'FVLBNL22',
  GILL: 'GILLNL2A',
  HAND: 'HANDNL2A',
  HHBA: 'HHBANL22',
  HSBC: 'HSBCNL2A',
  ICBK: 'ICBKNL2A',
  INGB: 'INGBNL2A',
  INSI: 'INSINL2A',
  ISBK: 'ISBKNL2A',
  KABA: 'KABANL2A',
  KASA: 'KASANL2A',
  KNAB: 'KNABNL2H',
  KOEX: 'KOEXNL2A',
  KRED: 'KREDNL2X',
  LOCY: 'LOCYNL2A',
  LOYD: 'LOYDNL2A',
  LPLN: 'LPLNNL2F',
  MHCB: 'MHCBNL2A',
  NNBA: 'NNBANL2G',
  NWAB: 'NWABNL2G',
  OVBN: 'OVBNNL22',
  RABO: 'RABONL2U',
  RBOS: 'RBOSNL2A',
  RBRB: 'RBRBNL21',
  SNSB: 'SNSBNL2A',
  SOGE: 'SOGENL2A',
  STAL: 'STALNL2G',
  TEBU: 'TEBUNL2A',
  TRIO: 'TRIONL2U',
  UBSW: 'UBSWNL2A',
  UGBI: 'UGBINL2A',
  VOWA: 'VOWANL21',
  ZWLB: 'ZWLBNL21'
};
